// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  background: #eef2f7;
  color: #0f172a;
}

/* LOGIN */

.login-page {
  width: 100%;
  min-height: 100vh;
  background:
    linear-gradient(
      135deg,
      #111827 0%,
      #3f0d1b 50%,
      #991b1b 100%
    );

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-box {
  width: 100%;
  max-width: 520px;

  background: #ffffff;

  border-radius: 28px;

  padding: 50px;

  box-shadow:
    0 20px 60px rgba(0,0,0,0.35);
}

.login-logo {
  width: 240px;
  display: block;
  margin: 0 auto 35px;
}

.login-box h1 {
  font-size: 48px;
  margin-bottom: 12px;
  color: #08132b;
}

.login-box p {
  color: #475569;
  margin-bottom: 35px;
  font-size: 18px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.login-form input {
  height: 64px;

  border-radius: 18px;

  border: 1px solid #cbd5e1;

  padding: 0 22px;

  font-size: 18px;

  outline: none;
}

.login-form input:focus {
  border-color: #b31316;
}

.login-form button {
  height: 64px;

  border: none;

  border-radius: 18px;

  background: #b31316;

  color: #ffffff;

  font-size: 20px;
  font-weight: bold;

  cursor: pointer;

  transition: 0.3s;
}

.login-form button:hover {
  background: #8f1013;
}

.login-message {
  margin-top: 20px;
  color: #b31316;
  font-weight: bold;
}

/* LAYOUT */

.layout {
  display: flex;
  min-height: 100vh;
}

/* SIDEBAR */

.sidebar {
  width: 320px;
  background: #08090d;
  color: #ffffff;

  display: flex;
  flex-direction: column;

  border-right: 1px solid rgba(255,255,255,0.06);
}

.sidebar-logo {
  padding: 28px;
  border-bottom: 1px solid rgba(255,255,255,0.06);

  display: flex;
  justify-content: center;
}

.sidebar-logo img {
  width: 240px;
  max-width: 100%;

  background: #ffffff;

  border-radius: 28px;

  padding: 18px;
}

.sidebar-menu {
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.sidebar-menu button {
  height: 64px;

  border: none;

  background: transparent;

  color: #ffffff;

  border-radius: 18px;

  display: flex;
  align-items: center;
  gap: 14px;

  padding: 0 20px;

  font-size: 24px;
  font-weight: 600;

  cursor: pointer;

  transition: 0.3s;
}

.sidebar-menu button:hover {
  background: rgba(255,255,255,0.05);
}

.sidebar-menu button.active {
  background: #b31316;
}

/* MAIN */

.main {
  flex: 1 1;
  background: #eef2f7;
}

/* TOPBAR */

.topbar {
  height: 110px;

  background: #ffffff;

  border-bottom: 1px solid #dbe1ea;

  padding: 0 35px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.topbar h1 {
  font-size: 56px;
  color: #08132b;
}

.topbar span {
  color: #64748b;
  font-size: 18px;
}


/* CONTENT */

.content {
  padding: 35px;
}

/* DASHBOARD */

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.card-dashboard {
  background: #ffffff;

  border-radius: 28px;

  padding: 35px;

  box-shadow:
    0 10px 30px rgba(0,0,0,0.04);
}

.card-dashboard h3 {
  font-size: 24px;
  color: #475569;
  margin-bottom: 20px;
}

.card-dashboard strong {
  font-size: 52px;
  color: #b31316;
}

/* PAGE */

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 25px;
}

.page-header h2 {
  font-size: 46px;
}

.primary {
  height: 60px;

  border: none;

  padding: 0 28px;

  background: #b31316;

  color: #ffffff;

  border-radius: 18px;

  font-size: 18px;
  font-weight: bold;

  cursor: pointer;
}

/* TABLE */

.table-container {
  background: #ffffff;

  border-radius: 28px;

  padding: 24px;

  overflow-x: auto;

  box-shadow:
    0 10px 30px rgba(0,0,0,0.04);
}

table {
  width: 100%;
  border-collapse: collapse;
}

th {
  text-align: left;
  padding: 24px 18px;

  border-bottom: 1px solid #e2e8f0;

  font-size: 20px;
}

td {
  padding: 22px 18px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 18px;
}

.small {
  height: 48px;

  border: none;

  padding: 0 22px;

  border-radius: 14px;

  background: #08132b;

  color: #ffffff;

  font-weight: bold;

  cursor: pointer;
}

/* MODAL */

.modal-overlay {
  position: fixed;
  inset: 0;

  background: rgba(15,23,42,0.75);

  backdrop-filter: blur(4px);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 9999;

  padding: 20px;
}

.modal {
  width: 100%;
  max-width: 1100px;

  background: #ffffff;

  border-radius: 32px;

  overflow: hidden;
}

.modal-header {
  padding: 35px;

  border-bottom: 1px solid #e2e8f0;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  font-size: 48px;
}

.modal-close {
  width: 52px;
  height: 52px;

  border: none;

  border-radius: 16px;

  background: #f1f5f9;

  font-size: 28px;

  cursor: pointer;
}

.modal-tabs {
  display: flex;
  gap: 20px;

  padding: 0 35px;

  border-bottom: 1px solid #e2e8f0;
}

.modal-tabs button {
  height: 70px;

  border: none;

  background: transparent;

  font-size: 24px;
  font-weight: bold;

  cursor: pointer;

  color: #0f172a;
}

.modal-tabs button.active {
  color: #b31316;
  border-bottom: 4px solid #b31316;
}

.modal-form {
  padding: 35px;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px;
}

.modal-form div {
  display: flex;
  flex-direction: column;
}

.modal-form label {
  margin-bottom: 10px;
  font-size: 22px;
  font-weight: bold;
}

.modal-form input {
  height: 64px;

  border-radius: 18px;

  border: 1px solid #cbd5e1;

  padding: 0 18px;

  font-size: 18px;
}

.modal-actions {
  grid-column: 1 / -1;

  display: flex;
  justify-content: flex-end;
  gap: 18px;

  margin-top: 20px;
}

.cancel {
  height: 58px;

  padding: 0 26px;

  border: none;

  border-radius: 18px;

  background: #e2e8f0;

  font-size: 18px;
  font-weight: bold;

  cursor: pointer;
}

.save {
  height: 58px;

  padding: 0 30px;

  border: none;

  border-radius: 18px;

  background: #16a34a;

  color: #ffffff;

  font-size: 18px;
  font-weight: bold;

  cursor: pointer;
}

/* BIOMETRIA */

.biometria-box {
  padding: 35px;
}

.biometria-box p {
  margin-bottom: 20px;
  font-size: 20px;
}

.camera-box {
  width: 100%;
  height: 520px;

  background: #08132b;

  border-radius: 28px;

  overflow: hidden;

  margin-bottom: 25px;

  border: 4px solid #e2e8f0;
}

.camera {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.actions {
  display: flex;
  gap: 18px;
}

.actions button {
  height: 60px;

  border: none;

  border-radius: 18px;

  padding: 0 28px;

  background: #08132b;

  color: #ffffff;

  font-size: 18px;
  font-weight: bold;

  cursor: pointer;
}

/* RESPONSIVO */

@media (max-width: 1200px) {

  .sidebar {
    width: 260px;
  }

  .topbar h1 {
    font-size: 42px;
  }

  .modal-form {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 900px) {

  .layout {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
  }

  .sidebar-menu {
    flex-direction: row;
    overflow-x: auto;
  }

  .sidebar-menu button {
    min-width: 220px;
  }

  .topbar {
    padding: 20px;
    height: auto;
  }

  .topbar h1 {
    font-size: 32px;
  }

  .content {
    padding: 20px;
  }

  .modal-header h2 {
    font-size: 32px;
  }

  .camera-box {
    height: 320px;
  }
}

@media (max-width: 600px) {

  .login-box {
    padding: 30px;
  }

  .login-box h1 {
    font-size: 34px;
  }

  .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 18px;
  }

  .topbar {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
  }

  .cards {
    grid-template-columns: 1fr;
  }

  .actions {
    flex-direction: column;
  }

  .camera-box {
    height: 260px;
  }
}
.camera-wrapper {
  position: relative !important;
  width: 100% !important;
  max-width: 1450px !important;
  height: 520px !important;
  margin: 20px auto 25px auto !important;
  border-radius: 26px !important;
  overflow: hidden !important;
  background: #000814 !important;
  border: 2px solid #d1d9e6 !important;
  box-shadow: 0 10px 40px rgba(0,0,0,0.25) !important;
}

.camera-wrapper .camera {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  display: block !important;
}

.face-overlay {
  position: absolute !important;
  inset: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  pointer-events: none !important;
  z-index: 5 !important;
}

.face-frame {
  width: 320px !important;
  height: 420px !important;
  border: 4px solid #d11212 !important;
  border-radius: 50% / 42% !important;
  box-shadow:
    0 0 25px rgba(209,18,18,0.9),
    inset 0 0 25px rgba(209,18,18,0.45) !important;
  animation: pulseFace 2s infinite !important;
}

.face-status {
  position: absolute !important;
  bottom: 28px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  background: rgba(0,0,0,0.75) !important;
  color: #ffffff !important;
  padding: 14px 24px !important;
  border-radius: 14px !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  border: 1px solid rgba(255,255,255,0.15) !important;
}

@keyframes pulseFace {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.03);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* =========================================
   RESPONSIVIDADE DASHBOARD RH FÊNIX
========================================= */

html,
body,
#root {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.layout {
    display: flex;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.sidebar {
    width: 280px;
    min-width: 280px;
    height: 100vh;
    overflow-y: auto;
}

.main {
    flex: 1 1;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
}

.content {
    padding: 24px;
    width: 100%;
    box-sizing: border-box;
}

.cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 24px;
    width: 100%;
}

.card-dashboard {
    min-height: 180px;
}

.table-container {
    width: 100%;
    overflow-x: auto;
    margin-top: 24px;
}

table {
    width: 100%;
}

.camera-wrapper {
    width: 100%;
    max-width: 1200px;
}

.camera {
    width: 100%;
    height: auto;
}

/* =========================================
   TELAS MENORES
========================================= */

@media (max-width: 1400px) {

    .cards {
        grid-template-columns: repeat(2, 1fr);
    }

}

@media (max-width: 900px) {

    .layout {
        flex-direction: column;
    }

    .sidebar {
        width: 100%;
        min-width: 100%;
        height: auto;
    }

    .main {
        height: auto;
    }

    .cards {
        grid-template-columns: 1fr;
    }

}

.config-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
  width: 100%;
}

.config-card {
  height: 180px;
  background: #e5e7eb;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  cursor: pointer;
  transition: 0.2s;
}

.config-card svg {
  font-size: 52px;
  color: #111827;
}

.config-card span {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.config-card:hover {
  background: #ffffff;
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA,UAAU;;AAEV;EACE,WAAW;EACX,iBAAiB;EACjB;;;;;;KAMG;;EAEH,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;;EAEhB,mBAAmB;;EAEnB,mBAAmB;;EAEnB,aAAa;;EAEb;gCAC8B;AAChC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;;EAEZ,mBAAmB;;EAEnB,yBAAyB;;EAEzB,eAAe;;EAEf,eAAe;;EAEf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;;EAEZ,YAAY;;EAEZ,mBAAmB;;EAEnB,mBAAmB;;EAEnB,cAAc;;EAEd,eAAe;EACf,iBAAiB;;EAEjB,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,YAAY;;AAEZ;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;;EAEd,aAAa;EACb,sBAAsB;;EAEtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,+CAA+C;;EAE/C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;;EAEf,mBAAmB;;EAEnB,mBAAmB;;EAEnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;;EAEZ,YAAY;;EAEZ,uBAAuB;;EAEvB,cAAc;;EAEd,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,eAAe;;EAEf,eAAe;EACf,gBAAgB;;EAEhB,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;;AAET;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA,WAAW;;AAEX;EACE,aAAa;;EAEb,mBAAmB;;EAEnB,gCAAgC;;EAEhC,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;;AAGA,YAAY;;AAEZ;EACE,aAAa;AACf;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;;EAEnB,mBAAmB;;EAEnB,aAAa;;EAEb;gCAC8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,SAAS;;AAET;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;;EAEZ,YAAY;;EAEZ,eAAe;;EAEf,mBAAmB;;EAEnB,cAAc;;EAEd,mBAAmB;;EAEnB,eAAe;EACf,iBAAiB;;EAEjB,eAAe;AACjB;;AAEA,UAAU;;AAEV;EACE,mBAAmB;;EAEnB,mBAAmB;;EAEnB,aAAa;;EAEb,gBAAgB;;EAEhB;gCAC8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;;EAElB,gCAAgC;;EAEhC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,YAAY;;EAEZ,YAAY;;EAEZ,eAAe;;EAEf,mBAAmB;;EAEnB,mBAAmB;;EAEnB,cAAc;;EAEd,iBAAiB;;EAEjB,eAAe;AACjB;;AAEA,UAAU;;AAEV;EACE,eAAe;EACf,QAAQ;;EAER,+BAA+B;;EAE/B,0BAA0B;;EAE1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,aAAa;;EAEb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;;EAEjB,mBAAmB;;EAEnB,mBAAmB;;EAEnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;;EAEb,gCAAgC;;EAEhC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,YAAY;;EAEZ,mBAAmB;;EAEnB,mBAAmB;;EAEnB,eAAe;;EAEf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;;EAET,eAAe;;EAEf,gCAAgC;AAClC;;AAEA;EACE,YAAY;;EAEZ,YAAY;;EAEZ,uBAAuB;;EAEvB,eAAe;EACf,iBAAiB;;EAEjB,eAAe;;EAEf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;;EAEb,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;;EAEZ,mBAAmB;;EAEnB,yBAAyB;;EAEzB,eAAe;;EAEf,eAAe;AACjB;;AAEA;EACE,mBAAmB;;EAEnB,aAAa;EACb,yBAAyB;EACzB,SAAS;;EAET,gBAAgB;AAClB;;AAEA;EACE,YAAY;;EAEZ,eAAe;;EAEf,YAAY;;EAEZ,mBAAmB;;EAEnB,mBAAmB;;EAEnB,eAAe;EACf,iBAAiB;;EAEjB,eAAe;AACjB;;AAEA;EACE,YAAY;;EAEZ,eAAe;;EAEf,YAAY;;EAEZ,mBAAmB;;EAEnB,mBAAmB;;EAEnB,cAAc;;EAEd,eAAe;EACf,iBAAiB;;EAEjB,eAAe;AACjB;;AAEA,cAAc;;AAEd;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;;EAEb,mBAAmB;;EAEnB,mBAAmB;;EAEnB,gBAAgB;;EAEhB,mBAAmB;;EAEnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;;EAEZ,YAAY;;EAEZ,mBAAmB;;EAEnB,eAAe;;EAEf,mBAAmB;;EAEnB,cAAc;;EAEd,eAAe;EACf,iBAAiB;;EAEjB,eAAe;AACjB;;AAEA,eAAe;;AAEf;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mCAAmC;EACnC;;kDAEgD;EAChD,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,sCAAsC;EACtC,uCAAuC;EACvC,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;;2CAE2C;;AAE3C;;;IAGI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;2CAE2C;;AAE3C;;IAEI;QACI,qCAAqC;IACzC;;AAEJ;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;AAEJ;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: Arial, Helvetica, sans-serif;\n  background: #eef2f7;\n  color: #0f172a;\n}\n\n/* LOGIN */\n\n.login-page {\n  width: 100%;\n  min-height: 100vh;\n  background:\n    linear-gradient(\n      135deg,\n      #111827 0%,\n      #3f0d1b 50%,\n      #991b1b 100%\n    );\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.login-box {\n  width: 100%;\n  max-width: 520px;\n\n  background: #ffffff;\n\n  border-radius: 28px;\n\n  padding: 50px;\n\n  box-shadow:\n    0 20px 60px rgba(0,0,0,0.35);\n}\n\n.login-logo {\n  width: 240px;\n  display: block;\n  margin: 0 auto 35px;\n}\n\n.login-box h1 {\n  font-size: 48px;\n  margin-bottom: 12px;\n  color: #08132b;\n}\n\n.login-box p {\n  color: #475569;\n  margin-bottom: 35px;\n  font-size: 18px;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.login-form input {\n  height: 64px;\n\n  border-radius: 18px;\n\n  border: 1px solid #cbd5e1;\n\n  padding: 0 22px;\n\n  font-size: 18px;\n\n  outline: none;\n}\n\n.login-form input:focus {\n  border-color: #b31316;\n}\n\n.login-form button {\n  height: 64px;\n\n  border: none;\n\n  border-radius: 18px;\n\n  background: #b31316;\n\n  color: #ffffff;\n\n  font-size: 20px;\n  font-weight: bold;\n\n  cursor: pointer;\n\n  transition: 0.3s;\n}\n\n.login-form button:hover {\n  background: #8f1013;\n}\n\n.login-message {\n  margin-top: 20px;\n  color: #b31316;\n  font-weight: bold;\n}\n\n/* LAYOUT */\n\n.layout {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* SIDEBAR */\n\n.sidebar {\n  width: 320px;\n  background: #08090d;\n  color: #ffffff;\n\n  display: flex;\n  flex-direction: column;\n\n  border-right: 1px solid rgba(255,255,255,0.06);\n}\n\n.sidebar-logo {\n  padding: 28px;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n\n  display: flex;\n  justify-content: center;\n}\n\n.sidebar-logo img {\n  width: 240px;\n  max-width: 100%;\n\n  background: #ffffff;\n\n  border-radius: 28px;\n\n  padding: 18px;\n}\n\n.sidebar-menu {\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.sidebar-menu button {\n  height: 64px;\n\n  border: none;\n\n  background: transparent;\n\n  color: #ffffff;\n\n  border-radius: 18px;\n\n  display: flex;\n  align-items: center;\n  gap: 14px;\n\n  padding: 0 20px;\n\n  font-size: 24px;\n  font-weight: 600;\n\n  cursor: pointer;\n\n  transition: 0.3s;\n}\n\n.sidebar-menu button:hover {\n  background: rgba(255,255,255,0.05);\n}\n\n.sidebar-menu button.active {\n  background: #b31316;\n}\n\n/* MAIN */\n\n.main {\n  flex: 1;\n  background: #eef2f7;\n}\n\n/* TOPBAR */\n\n.topbar {\n  height: 110px;\n\n  background: #ffffff;\n\n  border-bottom: 1px solid #dbe1ea;\n\n  padding: 0 35px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.topbar h1 {\n  font-size: 56px;\n  color: #08132b;\n}\n\n.topbar span {\n  color: #64748b;\n  font-size: 18px;\n}\n\n\n/* CONTENT */\n\n.content {\n  padding: 35px;\n}\n\n/* DASHBOARD */\n\n.cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 24px;\n}\n\n.card-dashboard {\n  background: #ffffff;\n\n  border-radius: 28px;\n\n  padding: 35px;\n\n  box-shadow:\n    0 10px 30px rgba(0,0,0,0.04);\n}\n\n.card-dashboard h3 {\n  font-size: 24px;\n  color: #475569;\n  margin-bottom: 20px;\n}\n\n.card-dashboard strong {\n  font-size: 52px;\n  color: #b31316;\n}\n\n/* PAGE */\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  margin-bottom: 25px;\n}\n\n.page-header h2 {\n  font-size: 46px;\n}\n\n.primary {\n  height: 60px;\n\n  border: none;\n\n  padding: 0 28px;\n\n  background: #b31316;\n\n  color: #ffffff;\n\n  border-radius: 18px;\n\n  font-size: 18px;\n  font-weight: bold;\n\n  cursor: pointer;\n}\n\n/* TABLE */\n\n.table-container {\n  background: #ffffff;\n\n  border-radius: 28px;\n\n  padding: 24px;\n\n  overflow-x: auto;\n\n  box-shadow:\n    0 10px 30px rgba(0,0,0,0.04);\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth {\n  text-align: left;\n  padding: 24px 18px;\n\n  border-bottom: 1px solid #e2e8f0;\n\n  font-size: 20px;\n}\n\ntd {\n  padding: 22px 18px;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 18px;\n}\n\n.small {\n  height: 48px;\n\n  border: none;\n\n  padding: 0 22px;\n\n  border-radius: 14px;\n\n  background: #08132b;\n\n  color: #ffffff;\n\n  font-weight: bold;\n\n  cursor: pointer;\n}\n\n/* MODAL */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n\n  background: rgba(15,23,42,0.75);\n\n  backdrop-filter: blur(4px);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  z-index: 9999;\n\n  padding: 20px;\n}\n\n.modal {\n  width: 100%;\n  max-width: 1100px;\n\n  background: #ffffff;\n\n  border-radius: 32px;\n\n  overflow: hidden;\n}\n\n.modal-header {\n  padding: 35px;\n\n  border-bottom: 1px solid #e2e8f0;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h2 {\n  font-size: 48px;\n}\n\n.modal-close {\n  width: 52px;\n  height: 52px;\n\n  border: none;\n\n  border-radius: 16px;\n\n  background: #f1f5f9;\n\n  font-size: 28px;\n\n  cursor: pointer;\n}\n\n.modal-tabs {\n  display: flex;\n  gap: 20px;\n\n  padding: 0 35px;\n\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.modal-tabs button {\n  height: 70px;\n\n  border: none;\n\n  background: transparent;\n\n  font-size: 24px;\n  font-weight: bold;\n\n  cursor: pointer;\n\n  color: #0f172a;\n}\n\n.modal-tabs button.active {\n  color: #b31316;\n  border-bottom: 4px solid #b31316;\n}\n\n.modal-form {\n  padding: 35px;\n\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 28px;\n}\n\n.modal-form div {\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-form label {\n  margin-bottom: 10px;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.modal-form input {\n  height: 64px;\n\n  border-radius: 18px;\n\n  border: 1px solid #cbd5e1;\n\n  padding: 0 18px;\n\n  font-size: 18px;\n}\n\n.modal-actions {\n  grid-column: 1 / -1;\n\n  display: flex;\n  justify-content: flex-end;\n  gap: 18px;\n\n  margin-top: 20px;\n}\n\n.cancel {\n  height: 58px;\n\n  padding: 0 26px;\n\n  border: none;\n\n  border-radius: 18px;\n\n  background: #e2e8f0;\n\n  font-size: 18px;\n  font-weight: bold;\n\n  cursor: pointer;\n}\n\n.save {\n  height: 58px;\n\n  padding: 0 30px;\n\n  border: none;\n\n  border-radius: 18px;\n\n  background: #16a34a;\n\n  color: #ffffff;\n\n  font-size: 18px;\n  font-weight: bold;\n\n  cursor: pointer;\n}\n\n/* BIOMETRIA */\n\n.biometria-box {\n  padding: 35px;\n}\n\n.biometria-box p {\n  margin-bottom: 20px;\n  font-size: 20px;\n}\n\n.camera-box {\n  width: 100%;\n  height: 520px;\n\n  background: #08132b;\n\n  border-radius: 28px;\n\n  overflow: hidden;\n\n  margin-bottom: 25px;\n\n  border: 4px solid #e2e8f0;\n}\n\n.camera {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.actions {\n  display: flex;\n  gap: 18px;\n}\n\n.actions button {\n  height: 60px;\n\n  border: none;\n\n  border-radius: 18px;\n\n  padding: 0 28px;\n\n  background: #08132b;\n\n  color: #ffffff;\n\n  font-size: 18px;\n  font-weight: bold;\n\n  cursor: pointer;\n}\n\n/* RESPONSIVO */\n\n@media (max-width: 1200px) {\n\n  .sidebar {\n    width: 260px;\n  }\n\n  .topbar h1 {\n    font-size: 42px;\n  }\n\n  .modal-form {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 900px) {\n\n  .layout {\n    flex-direction: column;\n  }\n\n  .sidebar {\n    width: 100%;\n  }\n\n  .sidebar-menu {\n    flex-direction: row;\n    overflow-x: auto;\n  }\n\n  .sidebar-menu button {\n    min-width: 220px;\n  }\n\n  .topbar {\n    padding: 20px;\n    height: auto;\n  }\n\n  .topbar h1 {\n    font-size: 32px;\n  }\n\n  .content {\n    padding: 20px;\n  }\n\n  .modal-header h2 {\n    font-size: 32px;\n  }\n\n  .camera-box {\n    height: 320px;\n  }\n}\n\n@media (max-width: 600px) {\n\n  .login-box {\n    padding: 30px;\n  }\n\n  .login-box h1 {\n    font-size: 34px;\n  }\n\n  .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 18px;\n  }\n\n  .topbar {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 14px;\n  }\n\n  .cards {\n    grid-template-columns: 1fr;\n  }\n\n  .actions {\n    flex-direction: column;\n  }\n\n  .camera-box {\n    height: 260px;\n  }\n}\n.camera-wrapper {\n  position: relative !important;\n  width: 100% !important;\n  max-width: 1450px !important;\n  height: 520px !important;\n  margin: 20px auto 25px auto !important;\n  border-radius: 26px !important;\n  overflow: hidden !important;\n  background: #000814 !important;\n  border: 2px solid #d1d9e6 !important;\n  box-shadow: 0 10px 40px rgba(0,0,0,0.25) !important;\n}\n\n.camera-wrapper .camera {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover !important;\n  display: block !important;\n}\n\n.face-overlay {\n  position: absolute !important;\n  inset: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  pointer-events: none !important;\n  z-index: 5 !important;\n}\n\n.face-frame {\n  width: 320px !important;\n  height: 420px !important;\n  border: 4px solid #d11212 !important;\n  border-radius: 50% / 42% !important;\n  box-shadow:\n    0 0 25px rgba(209,18,18,0.9),\n    inset 0 0 25px rgba(209,18,18,0.45) !important;\n  animation: pulseFace 2s infinite !important;\n}\n\n.face-status {\n  position: absolute !important;\n  bottom: 28px !important;\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n  background: rgba(0,0,0,0.75) !important;\n  color: #ffffff !important;\n  padding: 14px 24px !important;\n  border-radius: 14px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border: 1px solid rgba(255,255,255,0.15) !important;\n}\n\n@keyframes pulseFace {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  50% {\n    transform: scale(1.03);\n    opacity: 0.8;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* =========================================\n   RESPONSIVIDADE DASHBOARD RH FÊNIX\n========================================= */\n\nhtml,\nbody,\n#root {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n.layout {\n    display: flex;\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n}\n\n.sidebar {\n    width: 280px;\n    min-width: 280px;\n    height: 100vh;\n    overflow-y: auto;\n}\n\n.main {\n    flex: 1;\n    height: 100vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.content {\n    padding: 24px;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 24px;\n    width: 100%;\n}\n\n.card-dashboard {\n    min-height: 180px;\n}\n\n.table-container {\n    width: 100%;\n    overflow-x: auto;\n    margin-top: 24px;\n}\n\ntable {\n    width: 100%;\n}\n\n.camera-wrapper {\n    width: 100%;\n    max-width: 1200px;\n}\n\n.camera {\n    width: 100%;\n    height: auto;\n}\n\n/* =========================================\n   TELAS MENORES\n========================================= */\n\n@media (max-width: 1400px) {\n\n    .cards {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n}\n\n@media (max-width: 900px) {\n\n    .layout {\n        flex-direction: column;\n    }\n\n    .sidebar {\n        width: 100%;\n        min-width: 100%;\n        height: auto;\n    }\n\n    .main {\n        height: auto;\n    }\n\n    .cards {\n        grid-template-columns: 1fr;\n    }\n\n}\n\n.config-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 18px;\n  width: 100%;\n}\n\n.config-card {\n  height: 180px;\n  background: #e5e7eb;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.config-card svg {\n  font-size: 52px;\n  color: #111827;\n}\n\n.config-card span {\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.config-card:hover {\n  background: #ffffff;\n  transform: translateY(-3px);\n  box-shadow: 0 10px 25px rgba(0,0,0,0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
